// removed by extract-text-webpack-plugin
module.exports = {"DivisionPath":"DivisionPath--ED6Ry","DivisionSelector":"DivisionSelector--HGm27","Fragment":"Fragment--3eJ_S","AdminIcon":"AdminIcon--1MJRn","Current":"Current--3FhAD"};


//////////////////
// WEBPACK FOOTER
// ./src/app/components/DivisionPath/DivisionPath.scss
// module id = 943
// module chunks = 1